/* Cloudflare Turnstile für die Newsletter-Anmeldungen.
 *
 * Übernommen aus dem getDigital-Theme (assets/turnstile-gate.js), wo derselbe
 * Helfer seit dem 09.08.2026 läuft. Nur die globalen Namen sind andere, damit
 * beide Themes unabhängig voneinander bleiben.
 *
 * Ein gemeinsamer Helfer für die drei Anmeldewege - Popup, Anmeldeseite und
 * das Formular im Footer. Alle drei schicken an denselben Endpunkt, und die
 * Prüfung sitzt dort; ein Bot könnte sonst einfach eine andere Quelle angeben,
 * denn die kommt vom Client.
 *
 * ── Warum überhaupt ─────────────────────────────────────────────────────────
 *
 * Bei getDigital kamen über die Anmeldeseite 44 Eintragungen herein, von denen
 * nur 7 bestätigt wurden - 16 %, gegenüber 61 % beim Popup und 86 % im Footer.
 * Darunter Adressen, die zu einem deutschen Shop nicht passen; zwei der
 * Betroffenen haben die Bestätigungsmail als Spam gemeldet.
 *
 * Das Double-Opt-In hat gehalten - keiner von ihnen wurde Abonnent. Aber jede
 * dieser Mails geht an jemanden, der sie nie angefordert hat, und kostet
 * Zustellreputation. Bei Viamundi wiegt das schwerer als dort: Das SES-Konto
 * ist frisch und verträgt keine Beschwerden.
 *
 * ── Umsetzung ───────────────────────────────────────────────────────────────
 *
 * Unsichtbares Widget: Normale Besucher sehen nichts, es gibt kein Rätsel zu
 * lösen. Cloudflares Skript wird erst geladen, wenn zum ersten Mal ein Token
 * gebraucht wird - also beim Absenden, nicht bei jedem Seitenaufruf.
 *
 * Der Site-Key steht in den Theme-Einstellungen (settings.turnstile_site_key)
 * und wird über das Container-Element hereingereicht; JavaScript-Dateien sehen
 * kein Liquid. Der Key muss in Cloudflare für viamundi.de freigeschaltet sein - * Widgets sind an eine Hostnamen-Liste gebunden. Fehlt der Eintrag, liefert
 * Cloudflare kein Token, der Server antwortet mit "verification_failed", und
 * das Formular zeigt eine Fehlermeldung, ohne dass im Log etwas Auffälliges
 * steht.
 */
(function () {
  'use strict';

  /* Der onload-Parameter ist nicht optional: Cloudflare wirft
     "Remove async/defer from the Turnstile api.js script tag before using
     turnstile.ready()", wenn man bei einem nachgeladenen api.js stattdessen
     turnstile.ready() aufruft. Und nachladen wollen wir - sonst zahlt jeder
     Seitenaufruf für eine Anmeldung, die selten stattfindet. */
  var RUECKRUF = 'vmTurnstileBereit';
  var API = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
    + '?render=explicit&onload=' + RUECKRUF;

  var skriptGeladen = null;   // Promise, einmalig
  var widgetId = null;
  var container = null;

  function konfig() {
    return document.getElementById('vm-turnstile');
  }

  function ladeSkript() {
    if (skriptGeladen) return skriptGeladen;
    skriptGeladen = new Promise(function (auf, ab) {
      if (window.turnstile) return auf();
      window[RUECKRUF] = function () { auf(); };
      var s = document.createElement('script');
      s.src = API;
      s.async = true;
      s.onerror = function () { ab(new Error('turnstile_skript_nicht_geladen')); };
      document.head.appendChild(s);
    });
    return skriptGeladen;
  }

  function rendern(siteKey) {
    if (widgetId !== null) return;
    container = document.createElement('div');
    container.style.display = 'none';
    document.body.appendChild(container);
    widgetId = window.turnstile.render(container, {
      sitekey: siteKey,
      size: 'invisible',
      // Ohne das läuft ein unsichtbares Widget schon beim Rendern los, und das
      // execute() gleich danach beschwert sich über ein Widget, das bereits
      // arbeitet. Wir wollen den Zeitpunkt selbst bestimmen.
      execution: 'execute',
    });
  }

  /**
   * Holt einen frischen Token.
   *
   * Gibt null zurück, wenn Turnstile nicht eingerichtet oder nicht erreichbar
   * ist. Über das Ergebnis entscheidet dann der Server - der Client soll die
   * Anmeldung nicht selbst durchwinken, aber auch nicht mit einer kryptischen
   * Meldung abbrechen, wenn Cloudflare gerade klemmt.
   *
   * Es gibt nur ein Widget für alle Formulare, also darf immer nur ein Lauf
   * gleichzeitig unterwegs sein - sonst zieht der zweite dem ersten mit
   * reset() den Boden weg. Aufrufe reihen sich deshalb hintereinander.
   */
  var schlange = Promise.resolve();

  function holeToken() {
    var naechster = schlange.then(function () { return einLauf(); });
    // Ein Fehlschlag darf die Reihe nicht abreissen lassen.
    schlange = naechster.catch(function () {});
    return naechster;
  }

  async function einLauf() {
    var el = konfig();
    var siteKey = el && el.dataset.sitekey;
    if (!siteKey) return null;

    try {
      await ladeSkript();
      if (!window.turnstile) return null;
      rendern(siteKey);
      // Vor jedem Lauf zurücksetzen: Ein Token gilt einmal, und dieselbe Seite
      // kann mehrere Anmeldungen auslösen (Popup zu, Footer ausgefüllt).
      window.turnstile.reset(widgetId);
      return await new Promise(function (auf, ab) {
        var fertig = false;
        var zeit = setTimeout(function () {
          if (!fertig) { fertig = true; ab(new Error('turnstile_zeitueberschreitung')); }
        }, 15000);
        window.turnstile.execute(widgetId, {
          callback: function (token) {
            if (fertig) return;
            fertig = true; clearTimeout(zeit); auf(token);
          },
          'error-callback': function () {
            if (fertig) return;
            fertig = true; clearTimeout(zeit); ab(new Error('turnstile_fehler'));
          },
          'expired-callback': function () {
            if (fertig) return;
            fertig = true; clearTimeout(zeit); ab(new Error('turnstile_abgelaufen'));
          },
        });
      });
    } catch (e) {
      console.warn('[turnstile] kein Token:', e && e.message);
      return null;
    }
  }

  window.vmTurnstile = { holeToken: holeToken };
})();
